import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as cursorUsageEvent from '../cursor-usage-event'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: cursorUsageEvent.RESOURCE.payload.dimension.partialId,
      partialId: cursorUsageEvent.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'The Jira issue key associated with this event, if any.',
    isOptional: true,
    name: 'Jira Key',
    partialId: PartialId.Standard.create('jira_key'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
